import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import type { SemanticFaqItem } from '@/lib/semantic-content/types';

export default function FaqSection({ items }: { items: SemanticFaqItem[] }) {
  if (items.length === 0) {
    return null;
  }

  return (
    <section aria-labelledby="faq-heading" className="space-y-4">
      <div>
        <h2 id="faq-heading" className="text-3xl font-semibold tracking-tight text-foreground">
          Frequently asked questions
        </h2>
        <p className="mt-3 max-w-3xl text-base leading-7 text-muted-foreground">
          More FAQs will be added as we continue to work with our users and answer their questions.
        </p>
      </div>

      <div className="grid gap-4">
        {items.map((item) => (
          <Card key={item.question} className="border-border/60 bg-card/60 shadow-none">
            <CardHeader>
              <CardTitle className="text-xl">{item.question}</CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-base leading-7 text-muted-foreground">{item.answer}</p>
            </CardContent>
          </Card>
        ))}
      </div>
    </section>
  );
}
